import BetsDetail from './bets-detail';

export default BetsDetail;
